module.exports = __webpack_public_path__ + "2c3a60abb1fd4675c939f2623f939379.svg";